const careerEn = {
	breadcrumbs: { home: 'Home', career: 'Career' },
	hero: {
		title: 'Start your dream career',
		subtitle: 'Join Grameen Bazar and help transform rural commerce in Bangladesh into the digital age'
	},
	companyStats: [
		{ value: '500+', label: 'Employees' },
		{ value: '10+', label: 'Offices' },
		{ value: '98%', label: 'Employee Satisfaction' },
		{ value: '100+', label: 'Training Programs' }
	],
	jobsSection: { title: 'Open Positions', subtitle: 'Work with us and grow your career' },
	labels: {
		featured: 'Featured',
		postedSuffix: 'posted',
		salary: 'Salary',
		deadline: 'Application Deadline'
	},
	buttons: {
		viewDetails: 'View Details',
		apply: 'Apply',
		cancel: 'Cancel',
		submit: 'Submit Application',
		contact: 'Contact Us'
	},
	cta: {
		title: "Can't find a suitable position?",
		subtitle: 'Get in touch. We will notify you about new opportunities.',
		contact: 'Contact Us'
	},
	form: {
		titleSuffix: ' - Application Form',
		name: 'Name',
		email: 'Email',
		phone: 'Phone',
		education: 'Education',
		experience: 'Work Experience',
		uploadResume: 'Upload Resume (PDF, DOC, DOCX)'
	},
	snackbar: {
		success: 'Your application has been submitted. We will contact you soon.'
	},
	jobs: [
		{
			id: 1,
			title: 'Senior Software Engineer',
			department: 'IT',
			location: 'Dhaka',
			type: 'Full-time',
			experience: '5+ years',
			salary: '80,000 - 120,000 BDT',
			deadline: '30 April, 2024',
			posted: '5 days ago',
			description: 'Join our tech team. Experience in React, Node.js and Cloud services required.',
			requirements: ['At least 5 years of web development', 'Strong in React, Node.js', 'Experience with AWS/GCP', 'Team leadership experience'],
			benefits: ['Competitive salary', 'Health insurance', 'Annual bonus', 'Flexible hours'],
			featured: true
		},
		{
			id: 2,
			title: 'Marketing Manager',
			department: 'Marketing',
			location: 'Dhaka',
			type: 'Full-time',
			experience: '3+ years',
			salary: '50,000 - 80,000 BDT',
			deadline: '25 April, 2024',
			posted: '3 days ago',
			description: 'Looking for an experienced marketing manager to plan and execute digital campaigns.',
			requirements: ['3+ years in digital marketing', 'Experience running social campaigns', 'Team management skills', 'Budget handling experience'],
			benefits: ['Competitive salary', 'Health insurance', 'Learning budget'],
			featured: false
		},
		{
			id: 3,
			title: 'Customer Service Executive',
			department: 'Customer Service',
			location: 'Dhaka',
			type: 'Full-time',
			experience: '1+ year',
			salary: '25,000 - 40,000 BDT',
			deadline: '20 April, 2024',
			posted: '1 day ago',
			description: 'Energetic and experienced person to provide exceptional customer support.',
			requirements: ['1+ year experience in customer service', 'Excellent communication', 'Fluent in Bangla and English', 'Computer skills'],
			benefits: ['Competitive salary', 'Health insurance', 'Career growth'],
			featured: false
		}
	]
};

export default careerEn;


